module.exports = __webpack_public_path__ + "img/xzy04.5e058e99.png";